"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KanbanAside = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_dom_1 = require("react-dom");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const kanban_aside_style_1 = __importDefault(require("./kanban.aside.style"));
class KanbanAside extends react_1.default.PureComponent {
    render() {
        const { classes, children, expanded } = this.props;
        return (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [expanded && jsx_runtime_1.jsx("div", { className: classes.placeholder, role: "none" }, void 0),
                react_dom_1.createPortal(jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "aria-expanded": expanded }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.content }, { children: children }), void 0) }), void 0), document.body)] }, void 0));
    }
}
exports.KanbanAside = KanbanAside;
KanbanAside.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    expanded: prop_types_1.default.bool.isRequired
};
exports.default = react_jss_1.default(kanban_aside_style_1.default)(KanbanAside);
//# sourceMappingURL=kanban.aside.js.map